// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"ChatsPage_pageWrapper__1SXs3"};